var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon',{staticClass:"close-btn",attrs:{"type":"iconic_cancel_pop"},on:{"click":function (e) { return this$1.$emit('click', e); }}})}
var staticRenderFns = []

export { render, staticRenderFns }